import { z } from "zod";

/**
 * Deployment-time settings from `config.js`, which index.html loads before the
 * app. A deployment mounts its own copy over the shipped one, so one image
 * serves every environment. Strict so a misspelt key is reported, not ignored.
 * Read only through `@/constants/constants`.
 */
const runtimeConfigSchema = z
	.object({
		apiUrl: z.string(),
		keycloak: z
			.object({ url: z.string(), realm: z.string(), clientId: z.string() })
			.partial()
			.strict(),
		flipt: z
			.object({ url: z.string(), namespace: z.string() })
			.partial()
			.strict(),
		mapTilesUrl: z.string(),
	})
	.partial()
	.strict();

type RuntimeConfig = z.infer<typeof runtimeConfigSchema>;

const parseRuntimeConfig = (
	raw: unknown,
): { config: RuntimeConfig; issues: string[] } => {
	const result = runtimeConfigSchema.safeParse(raw ?? {});

	if (result.success) {
		return { config: result.data, issues: [] };
	}

	return {
		config: {},
		issues: result.error.issues.map(
			({ path, message }) => `${path.join(".") || "config"}: ${message}`,
		),
	};
};

const { config: runtimeConfig, issues: runtimeConfigIssues } =
	parseRuntimeConfig(window.__FRAUD_CONFIG__);

export type { RuntimeConfig };
export { parseRuntimeConfig, runtimeConfig, runtimeConfigIssues };
